import { render, staticRenderFns } from "./TeamScore.vue?vue&type=template&id=18331bd6&scoped=true&"
import script from "./TeamScore.vue?vue&type=script&lang=js&"
export * from "./TeamScore.vue?vue&type=script&lang=js&"
import style0 from "./TeamScore.vue?vue&type=style&index=0&id=18331bd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18331bd6",
  null
  
)

export default component.exports